module.exports = __webpack_public_path__ + "img/buck-icon.ff4ad7f9.svg";